// extracted by mini-css-extract-plugin
module.exports = {"uploadInput":"EditProfile_uploadInput__2IqQD"};